import { useState, useEffect } from 'react';
import { GetOpsLocationsRetailers } from '../libs/GraphQL';

const OPERATING_MODEL_LIST = ['BBS', 'Consignment', 'Traditional'];

export default function useGetRetailers({
  type = 'WHOLESALE',
  status = ['LIVE'],
} = {}) {
  const [retailerList, setRetailerList] = useState([]);
  const [errors, setErrors] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    GetOpsLocationsRetailers({ type, status })
      .then((response) => {
        const locations = response.data.opsLocations.locations;
        const result = locations.filter((item) =>
          OPERATING_MODEL_LIST.includes(item.operatingModel),
        );
        const retailers = result
          .filter((item) => item.retailer)
          .map((item) => ({
            name: item.retailer,
            id: item.id,
          }));
        retailers.sort((a, b) => a.name.localeCompare(b.name));
        // Build object with unique retailer names as keys and array of ids as values
        const retailerIdMap = {};
        retailers.forEach(({ name, id }) => {
          if (!retailerIdMap[name]) {
            retailerIdMap[name] = [];
          }
          retailerIdMap[name].push(id);
        });
        setRetailerList(retailerIdMap);
      })
      .catch((err) => {
        setErrors(err);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return { retailerList, errors, loading };
}
